module.exports = __webpack_public_path__ + "img/facebook1.99709390.png";